import { FormPagePropertyItem } from 'backend';
import { PROPERTY_TYPE } from 'shared';
import { getDatePropertyItemElement } from './date';
import { getPropertyItemElementFormCustomize } from './formCustomize';
import { getMailddressPropertyItemElement } from './mailAddress';
import { getMailRefusalFlagPropertyItemElement } from './mailRefusalFlag';
import { getMonthDayPropertyItemElement } from './monthDay';
import { getMultipleSelectionPropertyItemElement } from './multipleSelection';
import { getNumberPropertyItemElement } from './number';
import { getPasswordHashPropertyItemElement } from './passwordHash';
import { getSingleSelectionPropertyItemElement } from './singleSelection';
import { getTextPropertyItemElement } from './text';

// 入力項目を構成する HTML Element を表す型
export type PropertyItemElement = {
  [key: string]: HTMLElement | HTMLElement[];
};

export const getAllElements = (
  propertyItemElements: PropertyItemElement,
): HTMLElement[] => {
  return Object.values(propertyItemElements).flatMap((value) =>
    Array.isArray(value) ? value : [value],
  );
};

export const getPropertyItemElement = (
  propertyItem: FormPagePropertyItem,
  isFormCustomize: boolean,
): PropertyItemElement => {
  if (isFormCustomize) {
    return getPropertyItemElementFormCustomize(propertyItem);
  }
  switch (propertyItem.propertyType) {
    case PROPERTY_TYPE.mailAddress: {
      return getMailddressPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.text: {
      return getTextPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.number: {
      return getNumberPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.date: {
      return getDatePropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.monthDay: {
      return getMonthDayPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.singleSelection: {
      return getSingleSelectionPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.multipleSelection: {
      return getMultipleSelectionPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.passwordHash: {
      return getPasswordHashPropertyItemElement(propertyItem);
    }
    case PROPERTY_TYPE.mailRefusalFlag: {
      return getMailRefusalFlagPropertyItemElement(propertyItem);
    }
    default: {
      return {};
    }
  }
};
